import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_TraumaHistory = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_TraumaHistory' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Trauma History</h3></p>

                <p className='w-750'>
                    Please indicate if any of the following have happened to you and how it may have affected you.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever served in the military, law enforcement or as a first responder?</span>

                    <input type='radio' id='rbFirstResponder_Yes' name='rbFirstResponder' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFirstResponder_No' name='rbFirstResponder' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, indicate the capacity in which you served. <br />
                    <textarea id='txtFirstResponderIfYes' name='txtFirstResponderIfYes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever seen or been in a really bad accident?</span>
                    <textarea id='txtSeenBadAccident' name='txtSeenBadAccident' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has someone close to you ever been so badly injured or sick that s/he almost died?</span>
                    <textarea id='txtBadlyInjured' name='txtBadlyInjured' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has someone close to you ever died?</span>
                    <textarea id='txtEverDied' name='txtEverDied' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever been so sick that you or the doctor thought you might die?</span>
                    <textarea id='txtMightDie' name='txtMightDie' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever been unexpectedly separated from someone who you depend on for love or security for more than a few days?</span>
                    <textarea id='txtSeparatedFromSomeone' name='txtSeparatedFromSomeone' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has someone close to you ever tried to kill or hurt him/herself?</span>
                    <textarea id='txtHurtHimself' name='txtHurtHimself' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has someone ever physically hurt you or threatened to hurt you?</span>
                    <textarea id='txtHurtYou' name='txtHurtYou' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever been mugged or seen someone you care about get mugged?</span>
                    <textarea id='txtMugged' name='txtMugged' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Has someone ever kidnapped you?</span>
                    <textarea id='txtKidnappedYou' name='txtKidnappedYou' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever been attacked by a dog or other animal?</span>
                    <textarea id='txtAttackedByDog' name='txtAttackedByDog' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever seen or heard people physically fighting or threatening to hurt each other?</span>
                    <span className='small'>(In or outside of the family)</span>
                    <textarea id='txtHurtEachOther' name='txtHurtEachOther' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever witnessed a family member who was arrested or in jail?</span>
                    <textarea id='txtArrested' name='txtArrested' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever had a time in your life when you did not have a palace to live or enough food?</span>
                    <textarea id='txtEnoughFood' name='txtEnoughFood' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has someone ever made you see or do something sexual? Or have you seen or heard someone else being forced to do sex acts?</span>
                    <textarea id='txtSomethingSexual' name='txtSomethingSexual' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever watched people using drugs, like smoking drugs or using needles?</span>
                    <textarea id='txtUsingDrugs' name='txtUsingDrugs' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











